export default function isMobile() {
  const newLocal =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return newLocal.test(navigator.userAgent);
}
